<template>
  <div>
    <!-- <Divider orientation="left">单位基本信息</Divider> -->
    <Form :model="form" :rules="rules" :label-width="165">
      <Row :gutter="16">
        <Col span="12">
        <FormItem label="单位名称" prop="enterpriseName">
          <Input v-model.trim="form.enterpriseName" disabled></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="社会统一信用代码" prop="enterpriseCode">
          <Input v-model.trim="form.enterpriseCode" disabled></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="人事姓名" prop="personnelId">
          <Select v-model.trim="form.personnelId" style="width:100%" @on-change="personnalChange" disabled>
            <Option :value="value" v-for="{name,value} in enterpriseAgentList" :key="value">{{name}}</Option>
          </Select>
          <!-- <Input v-model.trim="form.personnelName" disabled placeholder=""></Input> -->

        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="人事身份证号">
          <Input v-model.trim="form.personnelIDCardNo" disabled placeholder=""></Input>
        </FormItem>
        </Col>
        <Col span="24">
        <FormItem label="人事联系方式">
          <Input v-model.trim="form.personnelPhone" disabled placeholder=""></Input>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem label="上传人事介绍信" prop="personnelLetterGuid">
          <!-- <Upload ref="personnelLetterGuid" :show-upload-list="false" :default-file-list="form.personnelLetterGuidPreview" :on-preview="handlePreview" :before-upload='(file)=>handleBefore("personnelLetterGuid")' :action="$baseURL+'/common/file/uploadfile'"
            :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'personnelLetterGuid')" :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'personnelLetterGuid',false)"
            :on-format-error="handleFormatError">
            <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
          </Upload> -->
          <div class="_link" v-for="item in form.personnelLetterGuidPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.personnelLetterGuidPreview.length<1">无</span>
        </FormItem>
        </Col>
        <Col span="12">
        <FormItem class="noticeTop" label="单位近一年税单" prop="enterpriseTaxReceiptGuid">
          <!-- <Upload  ref="enterpriseTaxReceiptGuid" :show-upload-list="false" :default-file-list="form.enterpriseTaxReceiptGuidPreview" style="flex:1;" :on-preview="handlePreview" :before-upload='(file)=>handleBefore("enterpriseTaxReceiptGuid")' :action="$baseURL+'/common/file/uploadfile'" :data="uploadData" :on-remove="(file, fileList)=>handleRemove(file, fileList, 'enterpriseTaxReceiptGuid',)"
            :on-success="(response, file, fileList)=>handleSuccess(response, file, fileList,'enterpriseTaxReceiptGuid')" :on-format-error="handleFormatError">
            <Button icon="ios-cloud-upload-outline" disabled>上传文件</Button>
          </Upload> -->
          <div class="_link" v-for="item in form.enterpriseTaxReceiptGuidPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.enterpriseTaxReceiptGuidPreview.length<1">无</span>
        </FormItem>
        <FormItem class="notice">
          <div>
            注：税单上未显示单位名称需要单位盖章
          </div>
        </FormItem>

        </Col>
      </Row>
    </Form>
  </div>
</template>
<script>
export default {
  props: {
    form: { type: Object },
    current: { type: Number },
    nextBtnClose: { type: Boolean },
    enterpriseAgentList: { type: Array },
    isEnterprise: { type: Boolean },
  },
  data() {
    return {
      format: ['jpg', 'png', 'jpeg'],
      accept: 'image/*',
      appInfoDataType: this.$store.state.appInfoDataType,
      uploadData: {},
      rules: {
        // personnelId: [{ required: true, type: 'number', message: '请选择', trigger: 'blur' }],
        // enterpriseName: [{ required: true, message: '请输入', trigger: 'blur' }],
        // enterpriseCode: [{ required: true, message: '请输入', trigger: 'blur' }],
        // isLaborDispatchPermit: [
        //   { required: true, message: '请选择', type: 'boolean', trigger: 'blur' },
        // ],
        // personnelIDCardNo: [{ required: true, message: '请输入', trigger: 'blur' }],
        // personnelPhone: [{ required: true, message: '请输入', trigger: 'change' }],
        // enterpriseBusinessLicenseGuid: [{ required: true, message: '请上传', trigger: 'blur' }],
        // personnelIDCardFrontGuid: [{ required: true, message: '请上传', trigger: 'blur' }],
        // personnelIDCardBackGuid: [{ required: true, message: '请上传', trigger: 'blur' }],
        // personnelLetterGuid: [{ required: true, message: '请上传', trigger: 'blur' }],
        // enterpriseTaxReceiptGuid: [{ required: true, message: '请上传', trigger: 'blur' }],
      },
      clList: ['rl', 'dw', 'yy', 'sh', 'rl'],
      selectList: [
        { name: '是', value: 1 },
        { name: '否', value: 0 },
      ],
    }
  },
  methods: {
    //下一步
    next(name, val) {
      //   this.$Message.success('Success!')
      let _this = this
      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        this.$emit('next', val, `/api/services/app/JZZJFApi/SaveAppEnterpriseInfo`)
      })
    },
    //暂存
    async submitStore() {
      this.$emit('submit', `/api/services/app/JZZJFApi/SaveAppEnterpriseInfo`, 0, '保存成功')
    },
    //移除文件
    async handleRemove(file, fileList, property, isArray) {
      this.$emit('handleRemove', file, fileList, property, isArray)
    },
    //文件上传成功
    handleSuccess(response, file, fileList, property, isArray) {
      this.$emit('handleSuccess', response, file, fileList, property, isArray)
      this.$refs['form' + this.current].validateField(property)
    },
    //上传前 用于单个上传清空上传列表
    handleBefore(property) {
      //不为数组时传一个删一个列表
      this.$refs[property].clearFiles()
    },
    //文件格式错误
    handleFormatError(file) {
      this.$emit('handleFormatError', file)
    },
    //文件预览
    handlePreview(file) {
      this.$emit('handlePreview', file)
    },
    //人事更改
    personnalChange(e) {
      this.$emit('personnalChange', e)
    },
  },
}
</script>
